import { Button, Tooltip, message } from 'antd';
import { UndoOutlined } from '@ant-design/icons';
import { restoreLead } from '../api/leadRestore';

interface Props {
  id: string;
  displayName: string;
  onRestored: () => void;
}

export function RestoreLeadButton({ id, displayName, onRestored }: Props) {
  return (
    <Tooltip title="Restore this lead. It comes back on the rep’s phone the next time the app syncs.">
      <Button
        type="text"
        aria-label={`Restore ${displayName}`}
        icon={<UndoOutlined />}
        onClick={async () => {
          try {
            await restoreLead(id);
            message.success(`Restored ${displayName}.`);
            onRestored();
          } catch (err: unknown) {
            message.error(
              (err as { message?: string }).message ?? 'Couldn’t restore this lead.',
            );
          }
        }}
      />
    </Tooltip>
  );
}
